<app-duplicate-name
  *ngIf="canShowDuplicateDrawingNames()"
  [duplicateNames]="duplicateDrawingNames"
  (decideForEachDrawing)="onDuplicateDecideForEachDrawing()"
  (skipDuplicates)="onDuplicateSkip()"
  (overwriteDuplicates)="onDuplicateOverwrite()"
></app-duplicate-name>
<section class="flex-column full-height" *ngIf="canShowDrawingFormSection()">
  <vdw-tabs-menu-card
    [identifier]="HEADER_IDENTIFIER"
    icon="add-blue"
    [action]="'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: 'DESIGN_LIBRARY.DESIGN' | bmsTranslate: {count: 1} | lowercase}"
    [title]="drawingFormComponent ? drawingFormComponent.drawingForm.value.name : ''"
    [actionText]="getLabelForUploadButton()"
    [extraInformationTitle]="getBatchUploadText()"
    [saving]="saving"
    [canShowSave]="canShowUploadButton()"
    [invalidFormMessageError]="canShowInvalidFormMessageError()"
    [showCustomErrorMessage]="canShowImageUploadError() || canShowOverwriteWarning()"
    [customErrorMessage]="getCustomErrorMessage()"
    (saveEvent)="uploadDrawings()"
    (backEvent)="cancelAddingDrawing()"
  >
    <button mat-stroked-button [disabled]="isCancelButtonDisabled()" (click)="cancelAddingDrawing()">
      {{ 'GENERAL.ACTIONS.CANCEL' | bmsTranslate }}
    </button>
    <ng-container *ngIf="canShowBatchButtons()">
      <vdw-progress-button
        *ngIf="canShowUseForButton()"
        label="DESIGN_LIBRARY.DETAILS.USE_FOR"
        [inProgress]="saving"
        [raisedButton]="false"
        [labelReplaceableValues]="{amount: getAmountOfDrawingImages()}"
        (progressClick)="useForAllDrawings()"
      >
      </vdw-progress-button>
      <button mat-flat-button type="button" *ngIf="canShowBackButton()" (click)="previousDrawing()">
        {{ 'GENERAL.NAVIGATION.PREVIOUS' | bmsTranslate }}
      </button>
      <button mat-flat-button color="primary" type="button" [disabled]="canDisableNextButton()" *ngIf="canShowNextButton()" (click)="nextDrawing()">
        {{ 'GENERAL.NAVIGATION.NEXT' | bmsTranslate }}
      </button>
    </ng-container>
  </vdw-tabs-menu-card>

  <mat-card class="overflow-auto">
    <mat-card-content>
      <article fxLayout="column">
        <ng-container *ngFor="let drawingImage of drawingImages; let drawingImageIndex = index">
          <app-add-drawing-form
            *ngIf="canShowDrawingForm(drawingImageIndex)"
            [areImagesUploading]="areImagesUploading"
            [drawingImage]="drawingImage"
            [drawing]="getDrawingFromDrawingsToBeSaved()"
            [drawingShapes]="drawingShapes"
            [drawingsToBeSaved]="drawingsToBeSaved"
            [drawingImageIndex]="drawingImageIndex"
            [canShowInvalidFormMessageError]="canShowInvalidFormMessageError()"
            [defaultDrawingShape]="defaultDrawingShape"
            [overwriteDuplicateNames]="overwriteDuplicateNames"
          ></app-add-drawing-form>
        </ng-container>
      </article>
    </mat-card-content>
  </mat-card>
</section>
